import { LegalShell } from '../components/LegalShell.js';

export function CookiesPage() {
  return (
    <LegalShell
      stamp="política de cookies"
      title="Os cookies que usamos"
      lastUpdated="11 de maio de 2026"
      intro={
        <p>
          Cookies são pequenos arquivos que o navegador armazena pra lembrar quem você é
          entre páginas. O SmartApply usa apenas <strong>cookies essenciais</strong>: sem
          eles, o login e a segurança da sua conta não funcionam. Sem Google Analytics, sem
          Facebook Pixel, sem nenhum tracker de marketing.
        </p>
      }
    >
      <h2>1. Por que não tem opt-out granular</h2>
      <p>
        A LGPD e a regulamentação europeia (GDPR) exigem opt-in explícito apenas pra cookies
        <strong> não-essenciais</strong> (marketing, analytics de terceiros, retargeting).
        Como o SmartApply só usa cookies essenciais à operação do serviço (autenticação,
        segurança, persistência de voto no roadmap), o banner que você vê é informativo, não
        consultivo.
      </p>
      <p>
        Você pode bloquear todos os cookies do site nas configurações do seu navegador, mas
        nesse caso o login da app autenticada não vai funcionar e seu voto no roadmap será
        contado uma vez por sessão em vez de ser persistente.
      </p>

      <h2>2. Lista completa de cookies</h2>
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Finalidade</th>
            <th>Tipo</th>
            <th>Duração</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <code>auth_session</code>
            </td>
            <td>
              Identificador da sua sessão autenticada. Definido após o login na app
              (localhost:5273 hoje, app.smartapply.com.br quando o domínio estiver propagado).
            </td>
            <td>Essencial · httpOnly · signed</td>
            <td>7 dias ou até logout</td>
          </tr>
          <tr>
            <td>
              <code>csrf_token</code>
            </td>
            <td>
              Token anti-CSRF (Cross-Site Request Forgery). Garante que operações de
              mutação venham do app real, não de um site malicioso.
            </td>
            <td>Essencial · signed</td>
            <td>Sessão</td>
          </tr>
          <tr>
            <td>
              <code>sa_voter</code>
            </td>
            <td>
              Identificador anônimo do seu browser pro roadmap público. Garante que cada
              browser conte apenas um voto por item, sem precisar criar conta pra votar.
            </td>
            <td>Essencial · httpOnly</td>
            <td>1 ano</td>
          </tr>
          <tr>
            <td>
              <code>sa_cookie_ack</code>
            </td>
            <td>
              Marca que você já viu o aviso de cookies. Sem isso, mostraríamos o banner em
              toda visita.
            </td>
            <td>Essencial · localStorage</td>
            <td>Persistente até você limpar</td>
          </tr>
        </tbody>
      </table>

      <h2>3. Como gerenciar</h2>
      <p>
        Cada navegador tem suas configurações:
      </p>
      <ul>
        <li>
          <strong>Chrome:</strong> Configurações → Privacidade e segurança → Cookies de
          terceiros
        </li>
        <li>
          <strong>Firefox:</strong> Configurações → Privacidade e Segurança → Cookies e
          dados do site
        </li>
        <li>
          <strong>Safari:</strong> Preferências → Privacidade → Gerenciar dados de sites
        </li>
        <li>
          <strong>Edge:</strong> Configurações → Cookies e permissões do site
        </li>
      </ul>
      <p>
        Bloquear cookies só do SmartApply é possível em todos eles. Limpar todos os cookies
        do navegador também funciona.
      </p>

      <h2>4. Cookies de terceiros</h2>
      <p>
        Não usamos cookies de terceiros (Google, Facebook, Hotjar, etc) no site público nem
        na app autenticada. Quando você roda uma análise, sua chave de IA é enviada
        diretamente pra Google, Anthropic ou OpenAI conforme você configurou. Cookies
        eventuais desses providers são governados pelas políticas deles, não pela nossa.
      </p>

      <h2>5. Atualizações</h2>
      <p>
        Se algum dia adicionarmos cookie não-essencial (ex: para teste A/B de UI), esta
        página será atualizada e o banner virará consultivo (com opções "aceitar essenciais"
        e "aceitar todos").
      </p>

      <blockquote>
        Quando o SmartApply rodava num computador local de teste, era impossível ter
        rastreamento. Mesmo migrando pra produção, o compromisso é manter assim: a única
        razão de existir cookie aqui é fazer o serviço funcionar pra você.
      </blockquote>
    </LegalShell>
  );
}
